<div
	class="compare-checkbox-wrapper hmf-mt-xxs hmf-mb-xxxs"
	role="checkbox"
	[attr.aria-checked]="checked()"
	[attr.aria-label]="checked() ? 'Selected for comparison' : 'Select for comparison'"
	tabindex="0"
	(keydown.tab)="tabPressed.emit()"
	(keydown.space)="onCompareChange($event)"
	(keydown.enter)="onCompareChange($event)"
	(click)="onCompareChange($event)">
		<hmf-checkbox
			class="compare-checkbox"
			aria-hidden="true"
			[tabIndex]="-1"
			[label]="'Compare'"
			[checked]="checked()">
		</hmf-checkbox>
</div>
